module.exports = __webpack_public_path__ + "img/cv.1e8fe55c.svg";